export default {
	title: 'device_information',
	components: [{ title: 'device_information', component: 'device_information' }],
};
